module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('custom-form', {
    attrs: {
      "fields": ['username', 'password'],
      "hiddenFields": {
        role: this.role
      },
      "submitLabel": "Einloggen",
      "url": "login"
    },
    on: {
      "submitted": _vm.loggedIn
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Login")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44046a9b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login.vue
// module id = 101
// module chunks = 0 1